import { Component, OnInit, Input } from '@angular/core';
import { Invoice } from '../../shared/models/invoice';

@Component({
  selector: 'app-invoice-in-view',
  templateUrl: './invoice-in-view.component.html',
  styleUrls: ['./invoice-in-view.component.scss']
})
export class InvoiceInViewComponent implements OnInit {

 	@Input() invoice: Invoice;

 	constructor() { }

  	ngOnInit() {
  	}

}
